document.addEventListener('DOMContentLoaded', () => {
  const searchForms = document.querySelectorAll('form[action*="/search"]');

  searchForms.forEach(form => {
    form.addEventListener('submit', (e) => {
      const input = form.querySelector('input[name="q"]');
      if (!input) return;

      const rawQuery = input.value.trim();
      if (rawQuery.length === 0) return;

      // すでにダブルクォーテーションで囲まれていなければ処理
      if (!rawQuery.startsWith('"') && !rawQuery.endsWith('"')) {
        // 1. 送信用のダミー(hidden)要素を一時的に作成して追加
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'q';
        hiddenInput.value = `"${rawQuery}"`;

        // 2. 元の表側入力欄の name="q" を一時的に消す（二重送信防止）
        input.removeAttribute('name');

        // 3. フォームにダミーを追加して送信
        form.appendChild(hiddenInput);
      }
    });
  });
});